(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["i-miei-valori"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('biri-values-v7')) return;
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const ease = value => value * value * (3 - 2 * value);

  class BiriValues extends HTMLElement {
    connectedCallback() {
      // Deferring also covers elements inserted by the Shopify theme editor.
      this._connectFrame = requestAnimationFrame(() => this.init());
    }

    init() {
      if (this._abort || !this.isConnected) return;
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this.stage = this.querySelector('[data-bv-stage]');
      this.items = Array.from(this.querySelectorAll('[data-bv-slide]')).map(el => ({
        el,
        panel: el.querySelector('[data-bv-panel]'),
        photo: el.querySelector('[data-bv-photo]'),
        copy: el.querySelector('[data-bv-copy]'),
        inner: el.querySelector('[data-bv-copy-inner]'),
        image: el.querySelector('.bv__image')
      }));
      this.counter = this.querySelector('[data-bv-current]');
      this.status = this.querySelector('[data-bv-status]');
      this.progress = this.querySelector('[data-bv-progress]');
      this.previous = this.querySelector('[data-bv-direction="-1"]');
      this.next = this.querySelector('[data-bv-direction="1"]');
      this.current = -1;
      this.editorIndex = null;
      const initialBounds = this.getBoundingClientRect();
      this.near = initialBounds.top < window.innerHeight + 700 && initialBounds.bottom > -700;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.compact = matchMedia('(max-height: 520px)');
      this.mobile = matchMedia('(max-width: 749px)');
      const measure = () => this.queueMeasure();
      [this.reduced, this.compact, this.mobile].forEach(query => query.addEventListener('change', measure, { signal }));
      window.addEventListener('resize', measure, { passive: true, signal });
      window.addEventListener('load', measure, { signal });
      window.addEventListener('scroll', () => {
        if (this.pinned && this.near) this.queueRender();
      }, { passive: true, signal });
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('keydown', event => this.onKey(event), { signal });

      document.addEventListener('shopify:block:select', event => {
        const index = this.items.findIndex(item => item.el.dataset.bvBlock === String(event.detail?.blockId));
        if (index < 0) return;
        this.editorIndex = index;
        this.goTo(index, false);
        this.queueRender();
      }, { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (this.items.some(item => item.el.dataset.bvBlock === String(event.detail?.blockId))) {
          this.editorIndex = null;
          this.queueRender();
        }
      }, { signal });
      document.addEventListener('shopify:section:reorder', measure, { signal });

      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(measure);
        this._resize.observe(this);
        this.items.forEach(item => this._resize.observe(item.inner));
      }
      if ('IntersectionObserver' in window) {
        this._intersection = new IntersectionObserver(entries => {
          this.near = entries[0].isIntersecting;
          // Render once even on exit, so the first/last state is never stale.
          this.queueRender();
          if (this.near) this.preload(Math.max(0, this.current));
        }, { rootMargin: '700px 0px' });
        this._intersection.observe(this);
      }
      if (document.fonts?.ready) {
        document.fonts.ready.then(() => { if (this.isConnected) this.queueMeasure(); });
      }
      this.measure();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._connectFrame);
      cancelAnimationFrame(this._measureFrame);
      cancelAnimationFrame(this._renderFrame);
      this._measureFrame = null;
      this._renderFrame = null;
      this._abort?.abort();
      this._abort = null;
      this._resize?.disconnect();
      this._intersection?.disconnect();
    }

    queueMeasure() {
      if (this._measureFrame) return;
      this._measureFrame = requestAnimationFrame(() => {
        this._measureFrame = null;
        if (this.isConnected) this.measure();
      });
    }

    queueRender() {
      if (this._renderFrame) return;
      this._renderFrame = requestAnimationFrame(() => {
        this._renderFrame = null;
        if (this.isConnected && this.pinned) this.render();
      });
    }

    getManualOffset() {
      const styles = getComputedStyle(this);
      const property = this.mobile?.matches ? '--bv-offset-mobile' : '--bv-offset-desktop';
      return Math.max(0, parseFloat(styles.getPropertyValue(property)) || 0);
    }

    isMobileViewport() {
      const width = Math.min(
        window.innerWidth || 99999,
        document.documentElement.clientWidth || 99999
      );
      return this.mobile?.matches || width <= 749;
    }

    animationEnabledForViewport() {
      if (this.isMobileViewport()) {
        // Mobile is opt-in: only the literal value "true" enables the effect.
        return this.getAttribute('data-bv-enabled-mobile') === 'true';
      }
      // Desktop remains on unless explicitly disabled.
      return this.getAttribute('data-bv-enabled-desktop') !== 'false';
    }

    headerCandidates() {
      const candidates = new Set();
      const selectors = [
        '.shopify-section-group-header-group',
        '[data-header-group]',
        '[id^="shopify-section"][class*="header"]',
        '.section-header',
        '.header-wrapper',
        'sticky-header',
        'header',
        '[role="banner"]'
      ];
      document.querySelectorAll(selectors.join(',')).forEach(node => candidates.add(node));

      // Also inspect what is physically touching the top edge. This catches
      // custom sticky wrappers whose class names are theme-specific.
      [2, Math.max(2, window.innerWidth / 2), Math.max(2, window.innerWidth - 2)].forEach(x => {
        document.elementsFromPoint(x, 2).forEach(node => candidates.add(node));
      });
      return candidates;
    }

    pinnedAncestor(node) {
      let current = node;
      while (current && current !== document.body && current !== document.documentElement) {
        const style = getComputedStyle(current);
        if (style.position === 'fixed' || style.position === 'sticky') return current;
        current = current.parentElement;
      }
      return null;
    }

    measureHeaderGeometry(naturalSectionTop) {
      let stickyBottom = 0;
      let flowBottom = 0;

      this.headerCandidates().forEach(node => {
        if (!(node instanceof Element) || this.contains(node)) return;
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        const rect = node.getBoundingClientRect();
        if (rect.height <= 0 || rect.width <= 0) return;
        if (rect.height > window.innerHeight * .45) return;

        // Bottom edge of the normal header group. Used only to remove a theme
        // spacer between header and this section; it never pulls across the header.
        if (rect.top < naturalSectionTop && rect.bottom <= naturalSectionTop + 4 && rect.bottom > 0) {
          flowBottom = Math.max(flowBottom, rect.bottom);
        }

        const pinned = this.pinnedAncestor(node);
        if (!pinned) return;
        const pinnedStyle = getComputedStyle(pinned);
        const pinnedRect = pinned.getBoundingClientRect();
        if (pinnedRect.height <= 0 || pinnedRect.bottom <= 0) return;
        const cssTop = parseFloat(pinnedStyle.top);
        const atTop = pinnedRect.top <= 4 || (Number.isFinite(cssTop) && Math.abs(pinnedRect.top - cssTop) <= 5);
        if (atTop) stickyBottom = Math.max(stickyBottom, pinnedRect.bottom);
      });

      if (stickyBottom > window.innerHeight * .45) stickyBottom = 0;
      return {
        stickyBottom: Math.max(0, Math.round(stickyBottom)),
        flowBottom: Math.max(0, Math.round(flowBottom))
      };
    }

    applyHeaderSeam(metrics, naturalSectionTop) {
      if (this.dataset.bvAutoHeader !== 'true') {
        this._seamPull = 0;
        this.style.setProperty('--bv-seam-pull', '0px');
        return;
      }

      // Use the lowest visible edge of the header. A positive difference is a
      // real spacer inserted by the theme/main wrapper, so we pull only that gap.
      const headerBottom = Math.max(metrics.flowBottom, metrics.stickyBottom);
      let pull = 0;
      if (headerBottom > 0) {
        const gap = naturalSectionTop - headerBottom;
        if (gap > 0 && gap <= 220) pull = Math.round(gap);
      }

      this._seamPull = pull;
      this.style.setProperty('--bv-seam-pull', `${pull}px`);
    }

    detectHeaderOffset(metrics) {
      if (this.dataset.bvAutoHeader !== 'true') return this.getManualOffset();
      // Sticky/fixed header: keep the animated stage directly below its lower edge.
      // If the theme cannot be detected reliably, use the merchant fallback.
      return metrics.stickyBottom > 0 ? metrics.stickyBottom : this.getManualOffset();
    }

    measure() {
      if (!this.stage) return;
      const currentPull = this._seamPull || 0;
      const naturalSectionTop = this.getBoundingClientRect().top + currentPull;
      const headerMetrics = this.measureHeaderGeometry(naturalSectionTop);
      this.applyHeaderSeam(headerMetrics, naturalSectionTop);
      this.offset = this.detectHeaderOffset(headerMetrics);
      this.style.setProperty('--bv-top', `${this.offset}px`);
      const ruler = this.querySelector('.bv__ruler');
      const viewport = ruler?.getBoundingClientRect().height || window.innerHeight;
      const stageHeight = Math.max(240, viewport - this.offset);
      const distance = clamp(Number(this.dataset.bvDistance) || 1, .6, 1.8);
      this.step = stageHeight * distance;
      const count = this.items.length;
      const travel = Math.max(0, count - 1) * this.step + stageHeight * .4;
      this.style.setProperty('--bv-stage-height', `${stageHeight}px`);
      this.style.setProperty('--bv-track-height', `${stageHeight + travel}px`);
      const supported = CSS.supports('position', 'sticky') && CSS.supports('clip-path', 'polygon(0 0,100% 0,100% 100%)');
      const deviceAnimationEnabled = this.animationEnabledForViewport();
      let animate = deviceAnimationEnabled && count > 1 && supported && !this.reduced.matches && !this.compact.matches;
      this.classList.toggle('bv--animated', animate);
      delete this.dataset.bvFallback;
      // Never cut off merchant copy. Long content falls back to normal cards.
      if (animate && this.items.some(item => item.inner.scrollHeight > item.copy.clientHeight + 2)) {
        animate = false;
        this.classList.remove('bv--animated');
        this.dataset.bvFallback = 'long-content';
      }
      this.pinned = animate;
      if (animate) {
        this.current = -1;
        this.render();
      } else {
        this.items.forEach(item => {
          item.el.removeAttribute('aria-hidden');
          item.el.inert = false;
          item.panel.style.removeProperty('transform');
          item.photo.style.removeProperty('opacity');
          item.copy.style.removeProperty('opacity');
          item.copy.style.removeProperty('transform');
        });
        this.style.removeProperty('--bv-current-ink');
        this.current = -1;
      }
    }

    transition(raw, index) {
      if (index === 0) return 1;
      // First 32% of each step is a reading pause, then the diagonal wipe.
      return clamp((raw - (index - 1) - .32) / .68);
    }

    render() {
      if (!this.pinned || !this.items.length) return;
      const raw = this.editorIndex === null
        ? Math.max(0, (this.offset - this.getBoundingClientRect().top) / this.step)
        : this.editorIndex;
      let active = 0;
      this.items.forEach((item, index) => {
        const incoming = this.transition(raw, index);
        const outgoing = index < this.items.length - 1 ? this.transition(raw, index + 1) : 0;
        const x = -(this.mobile.matches ? 105 : 78) * (1 - ease(incoming));
        item.panel.style.transform = `translate3d(${x.toFixed(3)}%, 0, 0)`;
        const photoAlpha = index === 0 ? 1 : ease(clamp((incoming - .12) / .88));
        item.photo.style.opacity = photoAlpha.toFixed(4);
        const appear = index === 0 ? 1 : ease(clamp((incoming - .65) / .35));
        const disappear = 1 - ease(clamp(outgoing / .3));
        item.copy.style.opacity = (appear * disappear).toFixed(4);
        item.copy.style.transform = `translate3d(${((1 - appear) * 22 - (1 - disappear) * 12).toFixed(2)}px, 0, 0)`;
        if (incoming >= .7) active = index;
      });
      const fraction = (Math.min(this.items.length - 1, raw) + 1) / this.items.length;
      this.progress.style.transform = `scaleX(${fraction.toFixed(4)})`;
      if (active !== this.current) this.setActive(active);
    }

    setActive(index) {
      this.current = index;
      const selected = this.items[index];
      this.items.forEach((item, i) => {
        const isActive = i === index;
        if (!isActive && item.el.contains(document.activeElement)) this.stage.focus({ preventScroll: true });
        item.el.setAttribute('aria-hidden', String(!isActive));
        item.el.inert = !isActive;
      });
      this.style.setProperty('--bv-current-ink', selected.el.dataset.bvInk || '#fffdf8');
      this.counter.textContent = String(index + 1).padStart(2, '0');
      this.status.textContent = `Valore ${index + 1} di ${this.items.length}: ${selected.el.dataset.bvTitle || ''}`;
      this.previous.disabled = index === 0;
      this.next.disabled = index === this.items.length - 1;
      if (this.near) this.preload(index);
    }

    preload(index) {
      this.items.slice(Math.max(0, index - 1), index + 2).forEach(item => {
        if (item.image) item.image.loading = 'eager';
      });
    }

    goTo(index, smooth = true) {
      if (!this.items.length) return;
      index = clamp(index, 0, this.items.length - 1);
      const behavior = smooth && !this.reduced.matches ? 'smooth' : 'instant';
      if (!this.pinned) {
        this.items[index].el.scrollIntoView({ behavior, block: 'start' });
        return;
      }
      const top = window.scrollY + this.getBoundingClientRect().top - this.offset + index * this.step + 1;
      this.preload(index);
      window.scrollTo({ top, behavior });
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const button = target.closest('[data-bv-direction]');
      if (!button || !this.contains(button) || button.disabled) return;
      this.editorIndex = null;
      this.goTo(this.current + Number(button.dataset.bvDirection));
    }

    onKey(event) {
      if (!this.pinned) return;
      const target = event.target;
      // Only use arrow keys while the stage or its own controls have focus.
      if (target !== this.stage && !target.closest?.('.bv__nav')) return;
      let index;
      if (event.key === 'ArrowRight') index = this.current + 1;
      else if (event.key === 'ArrowLeft') index = this.current - 1;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = this.items.length - 1;
      else return;
      event.preventDefault();
      this.editorIndex = null;
      this.goTo(index);
    }
  }

  customElements.define('biri-values-v7', BiriValues);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
